import React, { useEffect, useState } from 'react';
import { Field, Formik } from 'formik';

import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';

import DownloadIcon from '@material-ui/icons/GetApp';
import SendIcon from '@material-ui/icons/Send';

import SaveBox from '../../components/SaveBox';
import CustomMaskField from '../../components/MaskField';
import { useDispatch, useSelector } from 'react-redux';
import { downloadFile } from 'app/utils/forms/files';
import { CircularProgress, Drawer, InputAdornment } from '@material-ui/core';
import lineEndpoint from 'app/api/services/lineEndpoint';
import { errorHandler } from 'app/utils/errorHandler';
import { setPermissionaryCepe } from 'app/store/slices/line';
import notification from 'app/config/notification';
import { Alert } from '@material-ui/lab';
import { useSearchProcess } from '../../hooks/useSearchProcess';
import FindRequest from '../drawers/FindRequest';
import { SERVICES_CODES } from '../../../../config/services';
import { STATUS_CODES } from '../../../../config/status';

const servicesFilter = [
    { cdServico: SERVICES_CODES.SLIC_INCLUSAO_CONDUTOR_SUBSTITUTO },
    { cdServico: SERVICES_CODES.SLIC_SUBSTITUICAO_VEICULO },
    { cdServico: SERVICES_CODES.SLIC_TRANSFERENCIA_PERMISSAO },
    { cdServico: SERVICES_CODES.SLIC_PRORROGACAO_PRAZO },
];

const requestsfilters = {
    situacoes: [{ cdSituacao: STATUS_CODES.EM_ANALISE }, { cdSituacao: STATUS_CODES.AGUARDANDO_RESOLUCAO_PENDENCIAS }],
    servicos: servicesFilter,
};

const DocumentGenerationModal = (props) => {
    const dispatch = useDispatch();
    const { open, onClose } = props;

    const selectedLine = useSelector((state) => state.line.selected);
    const permissionaryCepe = useSelector((state) => state.line.permissionaryCepe);
    const selectedPermissionary = useSelector((state) => state.line.selectedPermissionary);

    const [loading, setLoading] = useState(false);
    const [openDrawer, setOpenDrawer] = useState(false);

    const {
        nuProcesso,
        setNuProcesso,
        nuSolicitacao,
        setNuSolicitacao,
        setCdProcesso,
        setCdSolicitacao,
        cdProcesso,
        cdSolicitacao,
        searchByProcess,
        searchByRequest,
        blockProcess,
        blockRequest,
        fetchingProcess,
        processo,
        solicitacao,
    } = useSearchProcess();

    useEffect(() => {
        setNuSolicitacao(permissionaryCepe?.cepe?.nuSolicitacao || '');
        setCdSolicitacao(permissionaryCepe?.cepe?.cdSolicitacao || '');

        if (permissionaryCepe && permissionaryCepe?.cepe.nuProcesso) {
            setNuProcesso(permissionaryCepe.cepe.nuProcesso);
            setCdProcesso(permissionaryCepe.cepe.cdProcesso);
        }
        // eslint-disable-next-line
    }, [permissionaryCepe, open]);

    const onClickDownloadCepe = async () => {
        await downloadFile({ idFile: permissionaryCepe?.idFileCrc, dispatch });
    };

    const onClickSendCepe = async () => {
        const cdCepe = permissionaryCepe?.cepe.cdCepe;
        const cdVeiculo = selectedPermissionary?.veiculos?.find((v) => v.boAtivo)?.cdVeiculo;
        const deCpfCnpj = selectedPermissionary?.deCpfCnpj;

        if (!cdProcesso) {
            notification('Informe um processo válido', {
                toastId: 'NO_CD_PROCESS',
                type: 'error',
            });
        }

        const request = { cdCepe, cdProcesso, cdSolicitacao, cdVeiculo, deCpfCnpj };

        if (cdCepe) {
            try {
                setLoading(true);
                let response = {};
                let resultMessage;
                if (cdProcesso && cdSolicitacao) {
                    response = await lineEndpoint.sendCepeWithRequest(request);
                    resultMessage = 'na solicitação ' + nuSolicitacao;
                } else if (cdProcesso && !cdSolicitacao) {
                    response = await lineEndpoint.sendCepeWithProcess(request);
                    resultMessage = 'no processo ' + nuProcesso;
                }

                if (response.status === 200) {
                    notification(`CEPE incluído ${resultMessage} com sucesso`, {
                        toastId: 'SUCCESSFUL_SEND_CEPE',
                        type: 'success',
                    });
                }
            } catch (error) {
                errorHandler(error.response?.status, error.response?.data?.message);
            } finally {
                setLoading(false);
                onClose();
            }
        }
    };

    const validateFormAndGenerateCepe = (formikBag) => {
        formikBag.validateForm().then((errors) => {
            formikBag.setFieldTouched('nuProcesso');
            if (Object.keys(errors).length === 0) {
                handleGenerateNewCepe();
            }
        });
    };

    const handleGenerateNewCepe = async () => {
        try {
            setLoading(true);
            const cdLinhaPermissionario = selectedPermissionary?.cdLinhaPermissionario;
            const cdServico = solicitacao ? solicitacao?.cdServico : null;
            const cdSolicitacao = solicitacao ? solicitacao?.cdSolicitacao : null;
            const nuSolicitacao = solicitacao ? solicitacao?.nuSolicitacaoFmt : null;
            // const cdProcesso = solicitacao ? solicitacao?.cdProcesso : processo?.id;
            const cdProc = solicitacao?.cdProcesso ?? processo?.id ?? cdProcesso;
            // const nuProcesso = solicitacao ? solicitacao?.nuProcesso : processo?.numero;
            const nuProc = solicitacao?.nuProcesso ?? processo?.numero ?? nuProcesso;
            const cdVeiculo = selectedPermissionary?.veiculos?.find((v) => v.boAtivo)?.cdVeiculo;

            if (cdProcesso) {
                const response = await lineEndpoint.generateCepe({
                    cdLinhaPermissionario,
                    cdServico,
                    cdVeiculo,
                    cdProcesso: cdProc,
                    nuProcesso: nuProc,
                    cdSolicitacao,
                    nuSolicitacao,
                });
                if (response.status === 200) {
                    setCdProcesso('');
                    setCdSolicitacao('');
                    setNuProcesso('');
                    setNuSolicitacao('');
                    dispatch(setPermissionaryCepe(response.data));
                    notification('CEPE gerado com sucesso', {
                        toastId: 'SUCCESSFUL_GENERATED_CEPE',
                        type: 'success',
                    });
                }
            } else {
                notification('Favor informar um número de processo válido', {
                    toastId: 'ERROR_INVALID_PROCESS',
                    type: 'error',
                });
            }
        } catch (error) {
            errorHandler(error.response?.status, error.response?.data?.message);
        } finally {
            setLoading(false);
        }
    };

    const handleSearchRequest = async (requestNumberFmt, formikBag) => {
        if (requestNumberFmt) {
            let deCpfCnpj = selectedPermissionary?.deCpfCnpj;
            await searchByRequest(requestNumberFmt, { deCpfCnpj });
            formikBag.setFieldTouched('nuProcesso');
        }
    };

    const handleSelectRequest = async (data, formikBag) => {
        setOpenDrawer(false);
        await searchByRequest(data.nuSolicitacaoFmt);
        formikBag.setFieldTouched('nuProcesso');
    };

    const handleSearchProcess = async (value) => {
        await searchByProcess(value);
        setLoading(false);
    };

    const onCancel = (e, reason) => {
        if (reason && reason === 'backdropClick') return;
        if (onClose) onClose(e);
    };

    return (
        <Formik initialValues={{ nuSolicitacao: '', nuProcesso: '' }} onSubmit={function () {}}>
            {(formikProps) => {
                return (
                    <Dialog fullWidth maxWidth="md" open={open} onClose={onCancel}>
                        <DialogTitle onClose={onClose} disableTypography>
                            <Typography color="secondary" variant="subtitle2">
                                Emissão CEPE
                            </Typography>
                            <Divider />
                        </DialogTitle>
                        <DialogContent>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Alert severity="info">
                                        Antes de emitir o documento, certifique-se de que todas as informações do
                                        permissionário foram salvas!
                                    </Alert>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Field
                                        disabled={blockRequest}
                                        component={CustomMaskField}
                                        variant="filled"
                                        fullWidth
                                        value={nuSolicitacao}
                                        mask={'999999/9999'}
                                        name="nuSolicitacao"
                                        label="Solicitação"
                                        onClickButton={() => setOpenDrawer(true)}
                                        onBlur={(e) => handleSearchRequest(e.target.value, formikProps)}
                                        onChange={(e) => setNuSolicitacao(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={8}>
                                    <Field
                                        name="nuProcesso"
                                        component={CustomMaskField}
                                        loading={fetchingProcess}
                                        disabled={blockProcess}
                                        value={nuProcesso}
                                        label="Número do Processo"
                                        mask={'9999.9999/999999'}
                                        validate={() => {
                                            const clearNuprocesso = nuProcesso.trim().replace(/\D/g, '');
                                            if (!clearNuprocesso) {
                                                return 'Campo obrigatório';
                                            }
                                        }}
                                        error={formikProps.errors['nuProcesso'] && formikProps.touched['nuProcesso']}
                                        helperText={
                                            formikProps.touched['nuProcesso'] && formikProps.errors['nuProcesso']
                                        }
                                        onBlur={(e) => {
                                            setLoading(true);
                                            formikProps.setFieldTouched('nuProcesso');
                                            handleSearchProcess(e.target.value);
                                        }}
                                        onChange={(e) => setNuProcesso(e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        InputLabelProps={{ shrink: true }}
                                        value={permissionaryCepe && `${permissionaryCepe.cepe?.nuCepeFmt || ''}`}
                                        variant="filled"
                                        fullWidth
                                        inputProps={{
                                            readOnly: true,
                                        }}
                                        disabled
                                        label="Nº CEPE"
                                        InputProps={
                                            loading
                                                ? {
                                                      endAdornment: (
                                                          <InputAdornment position="end">
                                                              <CircularProgress size={16} />
                                                          </InputAdornment>
                                                      ),
                                                  }
                                                : null
                                        }
                                    />
                                </Grid>
                                <Grid item xs={12} sm={8}>
                                    <TextField
                                        variant="filled"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        value={selectedLine?.deDescricao}
                                        disabled
                                        label="Linha"
                                    />
                                </Grid>
                                {/*</Grid>*/}
                                <Grid item xs={12}>
                                    {permissionaryCepe && permissionaryCepe?.idFileCrc && (
                                        <>
                                            <Button
                                                startIcon={<DownloadIcon />}
                                                color="secondary"
                                                style={{ marginRight: 16 }}
                                                onClick={onClickDownloadCepe}>
                                                Exibir
                                            </Button>
                                            <Button
                                                startIcon={<SendIcon />}
                                                color="primary"
                                                style={{ marginRight: 16 }}
                                                onClick={onClickSendCepe}>
                                                Encaminhar
                                            </Button>
                                        </>
                                    )}
                                </Grid>
                                <Grid item xs={12}>
                                    <SaveBox
                                        firstButtonDisabled={loading}
                                        onCancel={onClose}
                                        middleButtonLabel="Gerar"
                                        middleButtonDisabled={loading}
                                        onSave={() => validateFormAndGenerateCepe(formikProps)}
                                        removeSpacing
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <Drawer anchor="right" open={openDrawer} onClose={() => setOpenDrawer(false)}>
                            <FindRequest
                                onSave={(values) => handleSelectRequest(values, formikProps)}
                                onClose={() => setOpenDrawer(false)}
                                filters={requestsfilters}
                                hasSearch={true}
                            />
                        </Drawer>
                    </Dialog>
                );
            }}
        </Formik>
    );
};

export default DocumentGenerationModal;
